// extracted by mini-css-extract-plugin
module.exports = {"ProxySqlLbDashboard":"ProxySqlLbDashboard_NRHzc"};